import { render } from "./ForgotPasswordCard.vue?vue&type=template&id=5ec63c4a"
import script from "./ForgotPasswordCard.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__